import 'vue-tel-input/vue-tel-input.css'
import './assets/scss/style.scss'

import { createApp } from 'vue'
import VueTelInput from 'vue-tel-input'
import * as Sentry from '@sentry/vue'
import App from './App.vue'

const app = createApp(App)

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_APP_ENV,
  integrations: [
    Sentry.replayIntegration({
      minReplayDuration: 0,
      networkDetailAllowUrls: [
        /^https:\/\/dev\.setpile\.com\/.*/,
        /^https:\/\/api\.setpile\.com\/.*/,
        /^https:\/\/setpile\.com\/.*/
      ],
      networkRequestHeaders: ['X-Custom-Header'],
      networkResponseHeaders: ['X-Custom-Header'],
    })
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
})

app.use(VueTelInput)
app.mount('#app')
